import UIButton from 'UIComponents/button/UIButton';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AccountDisabledAlert(props) {
  const {
    inboxId
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "p-top-7 p-bottom-15 m-y-10 p-x-4 text-center",
    style: {
      backgroundColor: 'inherit'
    },
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customerDataCommunicator.Communicator.WhatsApp.accountDisabledAlert.title'
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("p", {
        className: "m-bottom-5 p-x-14 alert-message",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customerDataCommunicator.Communicator.WhatsApp.accountDisabledAlert.info'
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIButton, {
        href: `${getFullUrl('app')}/live-messages-settings/${PortalIdParser.get()}/inboxes/${inboxId || ''}/channels`,
        target: "_blank",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customerDataCommunicator.Communicator.WhatsApp.accountDisabledAlert.settingsLabel'
        })
      })
    })]
  });
}
AccountDisabledAlert.displayName = 'AccountDisabledAlert';